module.exports = __webpack_public_path__ + "img/default_profile.3129c9c7.svg";